export class Promocion {
  fechaIni: Date;
  fechaFin: Date;
  urlBanner: string;
  descPromocion: string;
}
